/* eslint no-undef: "warn" */
/* eslint brace-style: "warn" */
import axios from 'axios';
import apiOptions from '@/api/options';

let userId = -1;
const inDev = process.env.NODE_ENV === 'development';

export default {
  setUserId(id) {
    userId = id;
  },
  understandingYouOptions() {
    const options = apiOptions();
    return axios.get(`${options.baseUrl}MembershipApplication/UnderstandingYouOptions`, {
      headers: options.headers,
    });
  },
  uploadFilesForUser(id, isDegree, files) {
    const options = apiOptions();
    const headers = {};
    const formData = new FormData();

    files.forEach((f) => formData.append(f.name, f));

    Object.assign(headers, options.headers);

    headers['Content-Type'] = 'multipart/form-data';

    return axios.post(`${options.baseUrl}MembershipApplication/UserFiles?id=${id}&isDegreeCertificate=${isDegree}`, formData, {
      headers,
    });
  },
  getMembershipBenefits(membershipType) {
    const options = apiOptions();
    return axios.get(`${options.baseUrl}MembershipApplication/GetBenefitsAndWhatYouNeed/${membershipType}`, {
      headers: options.headers,
    });
  },
  saveMembershipBenefits(membershipType, data) {
    const options = apiOptions();

    return axios.post(`${options.baseUrl}MembershipApplication/SaveBenefitsAndWhatYouNeed${inDev ? 'Develop' : ''}/${membershipType}`, data, {
      headers: options.headers,
    });
  },
  saveUser(userCreate) {
    const options = apiOptions();

    return axios.post(`${options.baseUrl}User/SaveUser`, userCreate, {
      headers: options.headers,
    });
  },
  updateUser(userUpdate) {
    const options = apiOptions();
    return axios.post(`${options.baseUrl}User/UpdateUser`, userUpdate, {
      headers: options.headers,
    });
  },
  deleteDnnUser(userid, entraUserId) {
    const options = apiOptions();

    return axios.delete(`${options.baseUrl}User/DeleteUser?userId=${userid}&entraUserId=${entraUserId}`, {
      headers: options.headers,
    });
  },
  createApplication(application) {
    const options = apiOptions();

    return axios.post(`${options.baseUrl}User/SaveUserMemberData`, application, {
      headers: options.headers,
    });
  },
  fetchAddressViaPostcode(postcode) {
    const options = apiOptions();

    return axios.get(`${options.addressServiceUrl}Address/FindAddress?postcode=${postcode}`, {
      headers: options.headers,
    });
  },
  validatePostcode(postcode, country) {
    const options = apiOptions();

    return axios.get(`${options.addressServiceUrl}Address/ValidatePostcode?postcode=${postcode}&country=${country}`, {
      headers: options.headers,
    });
  },
  saveCorrespondence(correspondence) {
    const options = apiOptions();
    const url = inDev
      ? `${options.baseUrl}User/SaveCorrespondenceDevelop?userId=${userId}`
      : `${options.baseUrl}User/SaveCorrespondence`;

    return axios.post(url, correspondence, {
      headers: options.headers,
    });
  },
  savePliData(pliData) {
    const options = apiOptions();
    const url = inDev
      ? `${options.baseUrl}User/SavePliDataDevelop?userId=${userId}`
      : `${options.baseUrl}User/SavePliData`;

    return axios.post(url, pliData, {
      headers: options.headers,
    });
  },
  getApplication() {
    const options = apiOptions();
    const url = `${options.baseUrl}MembershipApplication/Get${inDev ? `Develop?userId=${userId}` : ''}`;

    return axios.get(url, {
      headers: options.headers,
    });
  },
  getFees() {
    const options = apiOptions();
    let url = '';
    if (inDev) {
      url = `${options.paymentsUrl}Fees/GetFeesDevelop?userId=${userId}&type=0`;
    } else {
      url = `${options.paymentsUrl}Fees/GetFees?type=0`;
    }

    return axios.get(url, {
      headers: options.headers,
    });
  },
  postFee(paymentOption) {
    const options = apiOptions();
    const url = `${options.paymentsUrl}Fees/${inDev ? `SetFeeDevelop?type=${0}&userid=${userId}` : `SetFee?type=${0}`}`;

    return axios.post(url, paymentOption, {
      headers: options.headers,
    });
  },
  postCardPayment(option, application) {
    const options = apiOptions();
    let url = '';
    if (inDev) {
      url = `${options.paymentsUrl}CardPayment/Post?userId=${userId}&applicationType=${application}`;
    } else {
      url = `${options.paymentsUrl}CardPayment/Post?applicationType=${application}`;
    }

    return axios.post(url, option, {
      headers: options.headers,
    });
  },
  postCardComplete(cardPaymentResult, application) {
    const options = apiOptions();
    const url = `${options.paymentsUrl}CardPayment/Complete?applicationType=${application}`;

    return axios.post(url, { result: cardPaymentResult }, {
      headers: options.headers,
    });
  },
  postCardCompleteBraintree(cardPaymentResult, application) {
    const options = apiOptions();
    const url = (inDev)
      ? `${options.paymentsUrl}CardPayment/CompleteBraintreeDevelop?applicationType=${application}&userId=${userId}`
      : `${options.paymentsUrl}CardPayment/CompleteBraintree?applicationType=${application}`;

    return axios.post(url, cardPaymentResult, {
      headers: options.headers,
    });
  },
  getCountryList() {
    const options = apiOptions();
    const url = `${options.addressServiceUrl}Address/GetCountries`;

    return axios.get(url, {
      headers: options.headers,
    });
  },
  completeApplication() {
    const options = apiOptions();
    let url = '';
    if (inDev) {
      url = `${options.baseUrl}MembershipApplication/CompleteDevelop?userId=${userId}`;
    } else {
      url = `${options.baseUrl}MembershipApplication/Complete`;
    }

    return axios.post(url, null, {
      headers: options.headers,
    });
  },
  getPasswordRegex() {
    const options = apiOptions();
    console.log('Loading password regex from API');
    return axios.get(`${options.baseUrl}MembershipApplication/GetPasswordRegex`, {
      headers: options.headers,
    });
  },
};
